import { render } from "./DownloadGrok.vue?vue&type=template&id=60c295d9"
import script from "./DownloadGrok.vue?vue&type=script&lang=js"
export * from "./DownloadGrok.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__